module.exports = __webpack_public_path__ + "static/media/KUZMA XL DC TURNTABLE.ac31ba91.png";